(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["register_something"] && !Shopify.designMode) return;
  try {
    

$(".registersomething-form").on("submit", function(event){
  event.preventDefault();

  const emailInput = document.getElementById("ContactFormEmail");
  const email = emailInput.value.trim();
  const regto = $('.registersomething').attr('data-regto');
  const errorBox = document.getElementById("registersomething-error");
  const successBox = document.getElementById("registersomething-success");

  // Reset mesaje
  errorBox.style.display = "none";
  errorBox.innerHTML = "";
  successBox.style.display = "none";
  //successBox.innerHTML = "";

  // 1. Validare dacă e completat
  if (!email) {
    errorBox.innerHTML = "Te rugăm să introduci o adresă de email.";
    errorBox.style.display = "block";
    return;
  }

  // 2. Validare format email (basic)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    errorBox.innerHTML = "Adresă de email invalidă.";
    errorBox.style.display = "block";
    return;
  }

  console.log("inscriere_concurs_1 Email valid:", email);
  var params = 'c=' + regto + '&e=' + email;
  console.log("inscriere_concurs_1 params:", params);

  // 3. Aici faci acțiunea ta (ex: trimiti către un API)
  $.ajax({
    type: 'GET',
    url: 'https://ics.cocosbio.ro/concurs/inscriere_concurs_1.aspx?' + params,
    dataType: 'text',
    success: function(data) { 
      console.log('inscriere_concurs_1 data: ', data);
      if (data == 'OK') {
          console.log('inscriere_concurs_1 data: ', data);
          successBox.style.display = "block";
  
      }
      else{
        console.log('inscriere_concurs_1 error: ', data);
        errorBox.innerHTML = "Ceva nu a mers bine. Te rugăm să încerci din nou.";
        errorBox.style.display = "block";
      }
    },
    error: function(data) { 
      console.log('inscriere_concurs_1 error: ', data);
      errorBox.innerHTML = "Ceva nu a mers bine. Te rugăm să încerci din nou.";
      errorBox.style.display = "block";
    }
  });

  // 4. Afișează mesaj de succes și ascunde formularul
  $(".registersomething-form").hide();
  //successBox.innerHTML = "";
  successBox.style.display = "block";
});


  } catch(e) { console.error(e); }
})();
})();
